import { useEffect, useState } from 'react'

import { LOADING_DELAY_MS } from './constants'

/**
 * `false` until `delayMs` has passed, then `true` — the gate every loading
 * surface behind the design toggle opens on. See `./constants` for why the
 * threshold exists and why it is 250ms.
 *
 * The initial value is computed rather than always `false`, so a caller that
 * explicitly asks for no delay (`delayMs = 0`) paints on the FIRST render
 * instead of a frame later. That matters for the parity story: antd's own
 * `Spin` shows immediately when `delay` is 0, which is its default.
 */
export const useLoadingDelay = (
  delayMs: number = LOADING_DELAY_MS
): boolean => {
  const [elapsed, setElapsed] = useState(() => delayMs <= 0)

  useEffect(() => {
    if (delayMs <= 0) {
      setElapsed(true)
      return undefined
    }

    setElapsed(false)
    const timeout = setTimeout(() => setElapsed(true), delayMs)

    return () => clearTimeout(timeout)
  }, [delayMs])

  return elapsed
}
